export default __webpack_public_path__ + "static/media/pdf-bg.f21bb407.png";